<template>
  <pict
    class="running-out__image m-auto"
    block-name="book-share"
    :default="imageProps.default"
    :sources="imageProps.sources"
    :alt="$t('alt')"
  />
</template>

<script>
import Pict from "@/shared/pict"

import imageL from "./images/sharing.png"
import imageL2x from "./images/sharing@2x.png"

export default {
  name: "RunningOutImage",
  components: {
    Pict
  },
  computed: {
    imageProps() {
      return {
        default: {
          src: imageL,
          srcset: {
            "2x": imageL2x
          }
        }
      }
    }
  },
  i18n: {
    messages: {
      en: {
        alt: "Illustration of two people sitting with white squares and a stack of books in the background and a laptop at their side, sharing a device and listening together with headphones."
      },
      de: {
        alt: "Illustration von zwei Personen in blau-schwarzer Kleidung, die sitzend und mit einem Stapel Bücher im Hintergrund und einem Laptop neben sich entspannen, sich ein Tablet teilen und gemeinsam etwas mit Kopfhörern anhören. "
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.running-out {
  ::v-deep &__image {
    width: auto;
  }
}
</style>
